import { useEffect, useRef, useState } from "react";
import { Link2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { translateError } from "@/i18n/errors";
import { LinkRow } from "@/components/admin/LinkImport";

// Creator only: one https APK link, downloaded server-side, created exactly like an upload with « Envoyer à l'atelier ».
export const AtelierLink = ({ onDone }) => {
  const { t } = useI18n();
  const [url, setUrl] = useState("");
  const [appId, setAppId] = useState("");
  const [apps, setApps] = useState([]);
  const [job, setJob] = useState(null);
  const timer = useRef(null);
  useEffect(() => {
    api.get("/admin/apps", { params: { limit: 50 } }).then(({ data }) => setApps(Array.isArray(data) ? data : data.items || [])).catch(() => {});
    return () => clearTimeout(timer.current);
  }, []);
  const poll = (id) => {
    timer.current = setTimeout(async () => {
      try {
        const { data } = await api.get(`/admin/link-imports/${id}`);
        setJob(data);
        if (data.done) return onDone();
      } catch { /* transient: keep polling */ }
      poll(id);
    }, 1500);
  };
  const start = async () => {
    try {
      const { data } = await api.post("/admin/link-imports", { urls: [url.trim()], atelier: true, app_id: appId || undefined });
      setJob(data);
      setUrl("");
      poll(data.id);
    } catch (err) { toast.error(translateError(err, t)); }
  };
  const running = job && !job.done;
  const ok = /^https:\/\/\S+$/i.test(url.trim());
  return (
    <section className="card-carbon min-w-0 space-y-3 rounded-2xl p-4" data-testid="atelier-link">
      <h2 className="flex items-center gap-2 font-display text-sm font-bold uppercase tracking-wider text-[var(--gold-bright)]"><Link2 className="h-4 w-4" /> {t("atelier.linkTitle")}</h2>
      <p className="break-words text-xs text-neutral-400">{t("atelier.linkHint")}</p>
      <input type="url" dir="ltr" value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://…/app-release.apk" maxLength={2000}
        aria-label={t("atelier.linkUrl")} className="w-full min-w-0 rounded-lg border border-neutral-700 bg-black/40 px-3 py-2 text-sm text-white" data-testid="atelier-link-url" />
      <select value={appId} onChange={(e) => setAppId(e.target.value)} aria-label={t("atelier.linkApp")} data-testid="atelier-link-app"
        className="w-full min-w-0 rounded-lg border border-neutral-700 bg-black/40 px-3 py-2 text-sm text-white">
        <option value="">{t("atelier.linkAuto")}</option>
        {apps.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
      </select>
      <button type="button" className="btn-gold btn-sm" disabled={running || !ok} onClick={start} data-testid="atelier-link-start">
        {running && <Loader2 className="h-4 w-4 animate-spin" />} {t("atelier.linkStart")}
      </button>
      {job && <ul className="space-y-2" data-testid="atelier-link-list">{job.items.map((it, i) => <LinkRow key={i} item={it} />)}</ul>}
    </section>
  );
};
